export class Category {
	constructor(idCategory, name, bannerURL, imageURL, routeURL) {
		this.idCategory = idCategory;
		this.name = name;
		this.bannerURL = bannerURL;
		this.imageURL = imageURL;
		this.routeURL = routeURL;
		this.subcategories = [];
	}
}

export class Subcategory {
	constructor(idSubCategory, name, imageURL, routeURL) {
		this.idSubCategory = idSubCategory;
		this.name = name;
		this.imageURL = imageURL;
		this.routeURL = routeURL;
		this.subcategories = null;
	}
}
